<div class="wiki-collections-container" [class.preview-mode]="isPreviewMode">
  <div class="wiki-collections-header" [class.preview-header-mode]="isPreviewMode">
    <div *ngIf="ghostItems?.length || (emptyResults$ | async) || (tree$ | async)?.children?.length">
      <ng-container *ngIf="selectedItems?.length > 0; else showResults">
        <div class="selected-items">
          <div class="title">
            {{ cardIdsSelected?.length || 0 }}
            {{ cardIdsSelected?.length === 1 ? 'Card' : 'Cards' }} selected
          </div>
          <div class="clear-button">
            <u-button class="clear-button" label="Clear" type="secondary-light" (onClick)="clearSelectedItems()"></u-button>
          </div>
        </div>
      </ng-container>
      <ng-template #showResults>
        <div class="title">
          {{ searchModel?.length > 0 ? 'Showing' : '' }} {{ itemsAmount }}
          {{ searchModel?.length > 0 ? (itemsAmount !== 1 ? 'results' : 'result') : itemsAmount !== 1 ? 'Cards' : 'Card' }}
        </div>
      </ng-template>
    </div>
    <div class="wiki-collections-buttons-container">
      <ng-container *ngIf="selectedItems?.length > 0">
        <div class="selected-actions">
          <u-button
            *ngIf="collection.policy?.isVerifier"
            class="verify-icon"
            elementSize="small"
            type="secondary"
            fontIcon="verify"
            [styles]="{ fontSize: '14px' }"
            (onClick)="updateVerificationStatus('Verify')"
            [pTooltip]="'Verify'"
            tooltipPosition="top"
            tooltipStyleClass="u-tooltip"
          ></u-button>
          <u-button
            *ngIf="collection.policy?.isVerifier"
            class="verify-icon"
            elementSize="small"
            type="secondary"
            fontIcon="unverify"
            [styles]="{ fontSize: '14px' }"
            (onClick)="updateVerificationStatus('Unverify')"
            [pTooltip]="'Unverify'"
            tooltipPosition="top"
            tooltipStyleClass="u-tooltip"
          ></u-button>
          <u-button
            [versionNumber]="2"
            [typeElement]="'secondary'"
            [sizeElement]="'medium'"
            [styleType]="'outlined'"
            fontIcon="exit"
            (onClick)="openMovePopup(selectedItems)"
            [pTooltip]="collectionContent.moveCollection"
            tooltipPosition="bottom"
            tooltipStyleClass="u-tooltip"
          ></u-button>
          <u-button
            class="delete-icon"
            elementSize="small"
            type="secondary"
            fontIcon="delete"
            [styles]="{ fontSize: '14px' }"
            (onClick)="openDeletePopup(selectedItems)"
            [pTooltip]="collectionContent.deleteCollection"
            tooltipPosition="bottom"
            tooltipStyleClass="u-tooltip"
          ></u-button>
        </div>
      </ng-container>
      <ng-container *ngIf="(tree$ | async)?.children?.length > 0 || searchModel">
        <search-expandable-button
          (onChange)="formInputChanged.next($event)"
          (click)="onFocusSearch()"
          size="large"
        ></search-expandable-button>
        <u-toggle-button
          *ngIf="previewHandlerService?.displayTogglePreview"
          (onChange)="previewHandlerService?.toggleResultsPreview(); isPreviewPressed = !isPreviewPressed"
          [checked]="previewHandlerService.previewViewModel.previewState === 'side'"
          [onIcon]="'toggle-preview'"
          [outlined]="true"
          [pTooltip]="previewHandlerService.getTogglePreviewTooltip()"
          tooltipPosition="left"
          tooltipStyleClass="u-tooltip"
        >
        </u-toggle-button>
        <u-button
          *ngIf="canEdit && !selectedItems?.length"
          #openCollectionButtonRef
          class="add-icon"
          data-cy="add-collection"
          elementSize="small"
          type="primary"
          fontIcon="plus"
          [iconStyles]="{ 'font-weight': 'bold' }"
          [styles]="{ fontSize: '14px' }"
          (onClick)="openNewCollectionPopup(openCollectionButtonRef)"
          [pTooltip]="collectionContent.createCollection"
          [label]="smallScreen ? '' : 'Create New'"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
        ></u-button>
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="loading == false && !ghostItems?.length && !(emptyResults$ | async) && !(tree$ | async)?.children?.length"
    class="wiki-collection-empty-state"
  >
    <empty-state [createNewOption]="canEdit" [type]="'wiki'" (onCreated)="onCreatedChild($event)"></empty-state>
  </div>
  <div class="search-results-container">
    <div *ngIf="ghostItems?.length">
      <ng-container *ngTemplateOutlet="ghost"></ng-container>
    </div>
    <wiki-tree
      [loading]="loading"
      class="wiki-search-results-list"
      [displayedContext]="displayedContext$ | async"
      (nextPage)="nextPage($event)"
      [componentFocused]="componentFocused === CollectionsComponentFocused.RESULTS"
      (componentFocusedFinish)="componentFocusedFinish.emit($event)"
      [listView]="{ isEditable: canEdit, isDraggable: false }"
      (selectedItemsUpdate)="selectedItemsUpdate($event)"
      [clearSelectedNodes]="clearSelectedNodes"
      (onDynamicCommand)="onDynamicCommand($event)"
      (titleChanged)="titleChanged($event)"
      [emptyResults]="emptyResults$ | async"
      listName="wiki_collections"
      pageType="wiki-collection"
      [changedData]="collectionChanged"
      (changePreviewMode)="previewMode = $event.isPreviewMode; showPreviewButton = $event.showBtn"
      [resizeChange]="isPreviewPressed"
      [updateHeight]="updateHeight"
      [tree]="(tree$ | async)?.children"
      [wikiId]="(tree$ | async)?.data?.id"
      [canEdit]="canEdit"
      [isSearchState]="!!searchModel"
      [highlights]="(tree$ | async)?.highlights"
      [onCreatedFolder]="onCreatedFolder"
    ></wiki-tree>
  </div>
</div>

<ng-template #ghost>
  <div *ngFor="let ghost of ghostItems">
    <result-ghost
      class="loading-result-ghost"
      [flatView]="ghost === 1"
      [ghostingLine]="2"
      [width]="ghost === 1 ? '280px' : '70%'"
    ></result-ghost>
  </div>
</ng-template>
